import { render, staticRenderFns } from "./DodatniSadrzajCreate.vue?vue&type=template&id=09945373&scoped=true&"
import script from "./DodatniSadrzajCreate.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzajCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09945373",
  null
  
)

export default component.exports